import { state } from "store/modules/snackbar/states";
import { mutations } from "store/modules/snackbar/mutations";

export default {
  state,
  mutations,
};
